import { NgModule } from '@angular/core';
import { MapSettingsComponent } from './map-settings.component';
import { SharedProviderModule } from '../../../shared.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LayerLoadingStatusComponent } from './layer-loading-status/layer-loading-status.component';
import { MarkerModeSettingsComponent } from './marker-mode-settings/marker-mode-settings.component';

@NgModule({
  imports: [
    SharedProviderModule,
    BrowserAnimationsModule
  ],
  declarations: [MapSettingsComponent, LayerLoadingStatusComponent, MarkerModeSettingsComponent],
  exports: [MapSettingsComponent]
})
export class MapSettingsModule {
}
